


























































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Form, Calendar, Picker, List, PullRefresh, Cell, CellGroup, Button, Col, Row } from "vant";
import btripServcice from "@/service/btripServcice";
import bus from "./bus";

@Component({
  name: "cardDetails",
  components: {
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
  },
})
export default class extends Vue {
  isShowOpen = true;
  isShowClose = false;
  TaskInfo = {};
  TaskInfoDictothers = {};
  handleResult = {
    TaskID: "",
    TaskStatus: "",
  };
  activated() {
    console.log(this.$route.params.item);

    this.TaskInfo = this.$route.params.item;
    this.TaskInfoDictothers = (this.TaskInfo as any).dictOthers;
    this.handleResult.TaskID = (this.TaskInfo as any).TaskID;
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  openDetails() {
    document.getElementById("Exhibition")?.classList.add("stylenone");
    this.isShowOpen = false;
    this.isShowClose = true;
  }
  closeDetails() {
    document.getElementById("Exhibition")?.classList.remove("stylenone");
    this.isShowOpen = true;
    this.isShowClose = false;
  }
  request() {
    btripServcice
      .saveTask(Object(this.handleResult))
      .then((json: any) => {
        if (json.isSucc) {
          this.$notify({ type: "success", message: "审批完毕" });
          this.$router.replace({
            path: "/btrip/applicationList",
          });
          this.$router.go(-1);
        }
      })
      .catch(() => {
        this.$notify({ type: "warning", message: "请检查您的网络" });
      });
  }
  reject() {
    this.handleResult.TaskStatus = "审批拒绝";
    bus.$emit("delCard", this.$route.params.item);
    this.request();
    console.log("拒绝了");
  }
  pass() {
    this.handleResult.TaskStatus = "审批通过";
    bus.$emit("delCard", this.$route.params.item);
    this.request();
    console.log("通过了");
  }
}
